import { useMsal } from '@azure/msal-react';
import { useCallback } from 'react';
import { freshSignIn } from './freshSignIn';

/**
 * Returns a callback that asks the person to sign in again and resolves to that sign-in's access token —
 * what erasing an account requires (ADR 0012 step 28). The policy is in `freshSignIn`, tested without a
 * browser; this only finds the account.
 */
export function useFreshSignIn(scope: string): () => Promise<string> {
  const { instance, accounts } = useMsal();

  return useCallback(async () => {
    const account = instance.getActiveAccount() ?? accounts[0];
    if (!account) throw new Error('No signed-in account.');
    return freshSignIn(instance, account, scope, window.location.origin);
  }, [instance, accounts, scope]);
}
